<template>
  <div class="sections-holder">
    <FaqSection>
      <span slot="heading">
        How do you know if your data is left or right skewed?
      </span>
      <div slot="content">
        <p>There are multiple ways to check whether your data is skewed to the left or to the right. It’s important to have a firm grasp on these methods, as skewed data can have a significant impact on our statistical analysis. Ultimately, it allows us to get a more complete understanding of the data we are working with.</p>
        <p>One way to determine if your data is left or right skewed is to visually inspect the distribution by creating a histogram.</p>
        <p>If most of the data points are clustered to the right, then your data is considered right skewed (or positively skewed), indicating a longer right tail:</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-01-faq-desktop.png" alt="Positive skew graph.">
        <p>Conversely, if most of the data points are clustered to the left, then your data is left skewed (or negatively skewed), indicating a longer left tail:</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-02-faq-desktop.png" alt="Negative skew graph.">
        <p>And finally, if the frequency of occurrence is mirrored, then there is zero skewness and the distribution is symmetrical:</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-03-faq-desktop.png" alt="Zero skew graph.">
        <p>Another way to confirm skewness is by calculating the skewness coefficient, which is a measure of the distribution's asymmetry. A positive value indicates right-skewed data, whereas a negative one means the data is skewed to the left.</p>
        <p>By being aware of the skewness of your data, you can take appropriate steps to mitigate its effects and ensure accurate statistical analysis.</p>
      </div>
    </FaqSection>
    <hr>
    <FaqSection>
      <span slot="heading">
        How to calculate skewness in Excel?
      </span>
      <div slot="content">
        <p>Excel allows you to calculate skewness using one of its two built-in functions: SKEW and SKEW.P. The former is suitable for sample data, whereas the latter returns the skewness of a distribution based on a population.</p>
        <p>The function requires only those cells that contain relevant data. Take, for example, the following dataset:</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-04-faq-desktop.png" alt="Dataset.">
        <p>In Excel, type SKEW, then select the cell range (C5:C14):</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-05-faq-desktop.png" alt="SKEW in the range (C5:C14).">
        <img class="no-top-margin" src="../../../../assets/images/calculators/skewness/skewness-06-faq-desktop.png" alt="The result is 0.13.">
        <p>By running the formula, we see that the sample data skewness is 0.13.</p>
        <p>Obtaining the population skewness is also straightforward. As previously mentioned, we use the SKEW.P function on the same cell rage (C5:C14):</p>
        <img src="../../../../assets/images/calculators/skewness/skewness-07-faq-desktop.png" alt="SKEW.P in the range (C5:C14).">
        <p>And here, we see that the population data skewness is 0.11.</p>
        <p>Whichever calculation method you chose, make sure you double-check your result using the Skewness Calculator above.</p>
      </div>
    </FaqSection>
  </div>
</template>

<script>
import FaqSection from './Section.vue';

export default {
  components: {
    FaqSection,
  },
};
</script>

<style lang="scss" scoped>
.sections-holder {
  hr {
    margin: var(--spacing-8) 0 var(--spacing-24);
    border: 1px solid rgba(0, 12, 31, 0.12);
  }
}
</style>
